'use client'

import React, { useEffect, useId, useState } from "react"
import { useSearchParams, usePathname, useRouter } from "next/navigation"
import Checkbox from "@/components/form/Checkbox"
import { changeFilters, toggleFilter } from "@/services/search"


type FiltersProps = {
    aroeven: Aroeven
}

export default function Filters({
    aroeven
}: FiltersProps) {

    const searchParams = useSearchParams()
    const pathname = usePathname()
    const { replace } = useRouter()

    const searchParam = 'all'

    return (
        <>
            <Checkbox
                className="actus"
                defaultChecked={searchParams.get(searchParam)?.includes("1")}
                toggle={() => replace(`${pathname}?${toggleFilter(searchParams, searchParam, "1").toString()}`, {
                    scroll: false
                })}
                label="Afficher les publications presse de l'ensemble du mouvement"
            />            
        </>
    )
}